import React, { useContext, useEffect, useState } from 'react';
import { Button } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';

import leafPng from 'assets/images/leaf.png';
import calendarPng from 'assets/images/calendar.png';
import { ModuleKeys } from 'services/task/modules-keys.constanst';
import { Task, TaskResponse, TaskState } from 'gql/graphql';
import { useGetTaskResponsesByTask } from 'services/task/querys';
import { useCreateResponseTask } from 'services/task/mutations';
import { OpenTaskContext } from '../../../scenes/Private/LoanList/LoanList';
import ModalEndSubmit from '../components/Organisms/Modals/ModalEndSubmit/ModalEndSubmit';
import StateTag from '../components/Atoms/Tags/StateTag/StateTag';
import { findTaskRules } from 'scenes/Private/LoanDetails/RulesTask.constanst';
import CardSomeoneElse from '../components/Atoms/Cards/CardSomeoneElse/CardSomeoneElse';
import QuestionBasic from '../components/Organisms/QuestionBasic/QuestionBasic';
import ModalTask from '../components/Organisms/Modals/ModalTask/ModalTask';
import CardBorrowerImpersonation from '../../CardBorrowerImpersonation/CardBorrowerImpersonation';

interface PropertyAccessDetailsProps {
  task: Task;
  visible?: boolean;
  handlerClose?: Function;
}

const PropertyAccessDetails = ({ task, visible, handlerClose }: PropertyAccessDetailsProps) => {

  const { taskKey, setTaskKey }: any = useContext(OpenTaskContext);

  const { execute: createResponseTask } = useCreateResponseTask();
  const { data: taskResponses, reexecute: getTaskResponses } = useGetTaskResponsesByTask({
    variables: { findResponsesByTask: { taskId: task._id } }
  });

  const [isReview, setIsReview] = useState(false);
  const [response, setResponse] = useState<TaskResponse>();
  const [isModalTaskVisible, setModalTaskVisible] = useState(false);
  const [isModalFinish, setModalFinish] = useState(false);
  const [isModalConfirmMe, setIsModalConfirmMe] = useState(false);

  useEffect(() => {
    if (!isModalTaskVisible && handlerClose)
      handlerClose();
  }, [isModalTaskVisible])

  useEffect(() => {
    setModalTaskVisible(!!visible);
  }, [visible])

  useEffect(() => {
    if (taskKey === 'property_access') {
      setModalTaskVisible(true);
    } else if (!!taskKey)
      setModalTaskVisible(false);
  }, [taskKey]);

  useEffect(() => {
    const _response: any = taskResponses?.find((item) => item.step === 1);
    setResponse(_response);
  }, [taskResponses]);

  const { taskName, phase } = findTaskRules(ModuleKeys.PROPERTY_ACCESS);
  const taskHasResponses = taskResponses && taskResponses.length > 0;

  return (
    <ModalTask
      visible={isModalTaskVisible}
      handlerSetVisibile={setModalTaskVisible}
      header={{
        title: <span>{taskName.toUpperCase()}</span>,
        actionLeft: isReview ? <StateTag state={TaskState.Review} size="large" /> : <img src={leafPng} alt="icon" className="paperPng" />,
      }}
      animationDirection="onRight"
      stepsTotal={1}
      currentStep={1}
      setStep={() => { }}
      footer={null}
      dots={false}
    >
      <div className="children property-access-detail">
        <div className="mt-50">
          <QuestionBasic
            question={
              <>
              <h3 className="h2">
                Who will be coordinating access for appraisers and other
                vendors?
              </h3>
              <CardBorrowerImpersonation hasResponses={taskHasResponses} />
              </>
            }
            disabled={true}
            type="dropdown"
            options={[
              {
                id: 1,
                title: 'Me',
                styleHover: 'option-hover-blue',
                onClick: () => { },
              },
              {
                id: 2,
                title: 'Someone else',
                dropdown: (metadata: any) => (
                  <CardSomeoneElse response={response} />
                ),
                styleHover: 'option-hover-blue',
                styleActive: 'option-active-blue',
                onClick: () => { }
              }
            ]}
            optionSelected={response?.key === 'someone-else' ? 2 : 1}
          />
        </div>
        {isModalConfirmMe && (
          <ModalEndSubmit
            visible={isModalConfirmMe}
            setVisible={setIsModalConfirmMe}
            buttonAction={{
              hidden: true
            }}
            modal={{
              title: 'Ready to submit?',
              description: (
                <h4 className="h4 h4-w4">{`After submitting, you’ll have to contact us if you want to make
              changes to the property access details`}</h4>
              )
            }}
            buttonSubmit={
              <Button htmlType='submit' className="button button-modal-ok" onClick={() => {}}>
                Yes, this is correct
              </Button>
            }
            buttonCancel={
              <Button className="button button-modal-cancel" onClick={() => setIsModalConfirmMe(false)}>
                I want to make changes
              </Button>
            }
            icon={calendarPng}
            className="modal-end-submit--white"
          />
        )}
      </div>
    </ModalTask>
  );
};
export default PropertyAccessDetails;
